// extracted by css-extract-rspack-plugin
export default {"cls1":"SaveReferencesButton-cls1_rWL","cls2":"SaveReferencesButton-cls2_DIv SaveReferencesButton-cls1_rWL"};